import React from 'react';
import './Experience.css';
import B from '../../images/businessnext.svg';
import Q from '../../images/Q.svg';
import P from '../../images/planindia.png';
import T from '../../images/techmahindra.png';
import S from '../../images/onemetric.png';
import C from '../../images/ciena.svg';

const data = [
  {
    company: 'Ciena',
    image: C,
    isContinued: true,
    whiteBg: true,
    roles: [
      {
        time: 'Aug 2025 – Present',
        designation: 'Software Application Engineer',
        team: 'Product Delivery',
        badge: 'Full-Time',
        tags: ['AngularTS', 'Java', 'Spring Boot', 'JavaScript', 'Neo4J', 'SQL','Camunda Workflows'],
        desc: "• Working as a fullstack developer in the Product Delivery team, taking end-to-end ownership of features and fixes.<br />• Delivered new client requirements and contributed to a high volume of bug fixes across the product.<br />• Continuously deepening expertise in both development practices and domain knowledge.",
      },
      {
        time: 'Jan 2025 – Jul 2025',
        designation: 'Blue Planet Inventory Developer',
        team: 'Internship',
        badge: 'Intern',
        tags: ['AngularTS', 'Java', 'Spring Boot', 'JavaScript', 'Neo4J'],
        desc: "• Joined as a BPI Developer intern and gained hands-on experience in an enterprise-scale telecom product environment.<br />• Contributed to feature development and bug fixes under the Blue Planet Inventory platform.<br />• Built a strong foundation in full-stack development practices.",
      },
    ],
  },
  {
    company: 'Suprdense',
    time: 'Aug 2024 – Dec 2024',
    designation: 'Frontend Engineer',
    team: 'Intern',
    tags: ['React.js', 'Redux', 'Material-UI', 'CSS', 'Chrome Extension'],
    desc: "• Worked on four products: SuprConfig, SuprSwitch, SuprExtension, and SuprDense Dashboard over five months.<br />• Developed and optimized responsive user interfaces using React.js, Redux, CSS, and Material-UI.<br />• Contributed to a Google Chrome extension project, enhancing accessibility and functionality across the platform.",
    image: S,
  },
  {
    company: 'Tech Mahindra Makers Lab',
    time: 'May 2024 – Jul 2024',
    designation: 'Backend Developer',
    team: 'Intern',
    tags: ['Python', 'Django', 'SQL'],
    desc: "• Worked extensively on the backend of the Intern's web portal using Python and Django, focusing on scalable and maintainable code.<br />• Enhanced database management with SQL, ensuring efficient data storage and retrieval.<br />• Collaborated with frontend developers to integrate user-friendly features and optimize performance.",
    image: T,
  },
  {
    company: 'Plan India',
    time: 'Jan 2024 – Mar 2024',
    designation: 'Technical Consultant & Program Implementation',
    team: 'Non-Profit',
    tags: ['Data Analysis', 'STEM Education', 'Career Guidance'],
    desc: "• Undertook data analysis for the 'Continuity in Education' initiative.<br />• Supported government school students (class 8–10) in designing STEM models.<br />• Participated in Career Guidance Fair and delivered counselling sessions for school students.<br />• Assisted class 10 students in board examination preparation.",
    image: P,
  },
  {
    company: 'Quatro',
    time: 'Aug 2023 – Dec 2023',
    designation: 'Freelance Web Developer',
    team: 'Freelance',
    tags: ['MongoDB', 'Express.js', 'React.js', 'Node.js', 'Figma'],
    desc: "• Delivered four full-stack web development projects within a five-month timeframe.<br />• Played a vital role in a collaborative team effort, consistently meeting deadlines.<br />• Received commendable feedback from clients across all engagements.",
    image: Q,
  },
  {
    company: 'Business Next',
    time: 'June 2023 – Aug 2023',
    designation: 'Product Development Intern',
    team: 'Frontend',
    tags: ['ReactJS', 'JavaScript', 'CSS', 'REST APIs', 'Axios'],
    desc: "• Contributed to the development of a meeting scheduling website, collaborating with cross-functional teams.<br />• Reduced re-rendering of React components by 25%, decreasing load time significantly.<br />• Worked extensively with RESTful APIs to integrate data from external sources.",
    image: B,
    whiteBg: true,
  },
];

const TagList = ({ tags }) => (
  <div className="expTags">
    {tags.map((tag, i) => (
      <span key={i} className="expTag">{tag}</span>
    ))}
  </div>
);

const Experience = () => {
  return (
    <div className='expboxbox'>
      <div className="ExpBox">
        <h1 className="ExpHeader">Experience</h1>
        <div className="ExpInner">
          {data.map((item, index) =>
            item.isContinued ? (
              <div key={index} className="ExpEx ExpEx--continued">
                <div className="ExpImg ExpImg--sticky">
                  <img src={item.image} alt="" className={item.whiteBg ? 'ExpImg--whiteBg' : ''} />
                </div>
                <div className="ExUselessInner ExpEx--continuedInner">
                  <h1 className='expCompany expCompany--continued'>{item.company}</h1>
                  <div className="CienaJourney">
                    {item.roles.map((role, rIdx) => (
                      <div key={rIdx} className="CienaRole">
                        <div className="CienaRoleMarker">
                          <span className="CienaRoleDot" />
                          {rIdx < item.roles.length - 1 && <span className="CienaRoleLine" />}
                        </div>
                        <div className="CienaRoleContent">
                          <div className="HeadingInner HeadingInner--wrap">
                            <div className="DesigBadgeRow">
                              <h3 className='expDesig'>{role.designation}</h3>
                              <span className={`ExpBadge ExpBadge--${role.badge === 'Full-Time' ? 'fte' : 'intern'}`}>
                                {role.badge}
                              </span>
                            </div>
                            <h4 className='expTime'>{role.time}</h4>
                          </div>
                          {role.team && <p className="expTeam">{role.team}</p>}
                          <div className="expDesc" dangerouslySetInnerHTML={{ __html: role.desc }} />
                          {role.tags && <TagList tags={role.tags} />}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ) : (
              <div key={index} className="ExpEx">
                <div className="ExpImg">
                  <img src={item.image} alt="" className={item.whiteBg ? 'ExpImg--whiteBg' : ''} />
                </div>
                <div className="ExUselessInner">
                  <div className="ExpInnerHeading">
                    <div className="HeadingInner HeadingInner--wrap">
                      <div className="DesigBadgeRow">
                        <h1 className='expCompany'>{item.company}</h1>
                        {item.team && (
                          <span className="ExpBadge ExpBadge--intern">{item.team}</span>
                        )}
                      </div>
                      <h4 className='expTime'>{item.time}</h4>
                    </div>
                    <h3 className='expDesig'>{item.designation}</h3>
                  </div>
                  <div className="expDesc" dangerouslySetInnerHTML={{ __html: item.desc }} />
                  {item.tags && <TagList tags={item.tags} />}
                </div>
              </div>
            )
          )}
        </div>
      </div>
    </div>
  );
};

export default Experience;